import { render, staticRenderFns } from "./LookupsForm.vue?vue&type=template&id=1bbf4a44&scoped=true&"
import script from "./LookupsForm.vue?vue&type=script&lang=js&"
export * from "./LookupsForm.vue?vue&type=script&lang=js&"
import style0 from "./LookupsForm.vue?vue&type=style&index=0&id=1bbf4a44&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbf4a44",
  null
  
)

export default component.exports